export default {
    'Angiosperm': {
        'Eudicots': {
            'Malvales': {
                'Malvaceae': {
                    'Abelmoschus': 'Abelmoschus',
                    'Bombax': 'Bombax',
                    'Corchorus': 'Corchorus',
                    'Firmiana': 'Firmiana',
                    'Gossypium': 'Gossypium',
                    'Hibiscus': 'Hibiscus',
                    'Microcos': 'Microcos',
                    'Theobroma': 'Theobroma',
                },
                'Thymelaeaceae': {
                    'Aquilaria': 'Aquilaria',
                },
                'Dipterocarpaceae': {
                    'Hopea': 'Hopea',
                    'Vatica': 'Vatica',
                },
                'Meliaceae': {
                    'Toona': 'Toona',
                },
            },
            'Fabales': {
                'Fabaceae': {
                    'Acacia': 'Acacia',
                    'Aeschynomene': 'Aeschynomene',
                    'Ammopiptanthus': 'Ammopiptanthus',
                    'Apios': 'Apios',
                    'Arachis': 'Arachis',
                    'Astragalus': 'Astragalus',
                    'Bauhinia': 'Bauhinia',
                    'Caragana': 'Caragana',
                    'Castanospermum': 'Castanospermum',
                    'Cercis': 'Cercis',
                    'Crotalaria': 'Crotalaria',
                    'Dalbergia': 'Dalbergia',
                    'Delonix': 'Delonix',
                    'Echinosophora': 'Echinosophora',
                    'Geoffroea': 'Geoffroea',
                    'Gleditsia': 'Gleditsia',
                    'Glycine': 'Glycine',
                    'Glycyrrhiza': 'Glycyrrhiza',
                    'Haematoxylum': 'Haematoxylum',
                    'Indigofera': 'Indigofera',
                    'Lathyrus': 'Lathyrus',
                    'Leucaena': 'Leucaena',
                    'Lotus': 'Lotus',
                    'Lupinus': 'Lupinus',
                    'Medicago': 'Medicago',
                    'Neltuma': 'Neltuma',
                    'Ormosia': 'Ormosia',
                    'Oxytropis': 'Oxytropis',
                    'Phaseolus': 'Phaseolus',
                    'Phyllolobium': 'Phyllolobium',
                    'Pisum': 'Pisum',
                    'Pongamia': 'Pongamia',
                    'Psophocarpus': 'Psophocarpus',
                    'Pueraria': 'Pueraria',
                    'Robinia': 'Robinia',
                    'Senna': 'Senna',
                    'Sophora': 'Sophora',
                    'Stylosanthes': 'Stylosanthes',
                    'Styphnolobium': 'Styphnolobium',
                    'Tamarindus': 'Tamarindus',
                    'Trifolium': 'Trifolium',
                    'Trigonella': 'Trigonella',
                    'Tylosema': 'Tylosema',
                    'Vicia': 'Vicia',
                    'Vigna': 'Vigna',
                },
                'Polygalaceae': {
                    'Epirixanthes': 'Epirixanthes',
                    'Polygala': 'Polygala',
                },
                'Surianaceae': {
                    'Suriana': 'Suriana',
                },
            },
            'Sapindales': {
                'Sapindaceae': {
                    'Acer': 'Acer',
                    'Litchi': 'Litchi',
                    'Nephelium': 'Nephelium',
                    'Sapindus': 'Sapindus',
                    'Xanthoceras': 'Xanthoceras',
                },
                'Meliaceae': {
                    'Aglaia': 'Aglaia',
                },
                'Simaroubaceae': {
                    'Ailanthus': 'Ailanthus',
                },
                'Rutaceae': {
                    'Citrus': 'Citrus',
                    'Limonia': 'Limonia',
                    'Melicope': 'Melicope',
                    'Murraya': 'Murraya',
                    'Phellodendron': 'Phellodendron',
                    'Tetradium': 'Tetradium',
                },
                'Anacardiaceae': {
                    'Cotinus': 'Cotinus',
                    'Mangifera': 'Mangifera',
                    'Spondias': 'Spondias',
                },
                'Nitrariaceae': {
                    'Nitraria': 'Nitraria',
                    'Peganum': 'Peganum',
                },
            },
            'Asterales': {
                'Asteraceae': {
                    'Achillea': 'Achillea',
                    'Ageratum': 'Ageratum',
                    'Ainsliaea': 'Ainsliaea',
                    'Arctium': 'Arctium',
                    'Artemisia': 'Artemisia',
                    'Aster': 'Aster',
                    'Aucklandia': 'Aucklandia',
                    'Bidens': 'Bidens',
                    'Blumea': 'Blumea',
                    'Carpesium': 'Carpesium',
                    'Carthamus': 'Carthamus',
                    'Chamaemelum': 'Chamaemelum',
                    'Chrysanthemum': 'Chrysanthemum',
                    'Cichorium': 'Cichorium',
                    'Dichrocephala': 'Dichrocephala',
                    'Diplostephium': 'Diplostephium',
                    'Duhaldea': 'Duhaldea',
                    'Erigeron': 'Erigeron',
                    'Eupatorium': 'Eupatorium',
                    'Glebionis': 'Glebionis',
                    'Helianthus': 'Helianthus',
                    'Lactuca': 'Lactuca',
                    'Leibnitzia': 'Leibnitzia',
                    'Leucomeris': 'Leucomeris',
                    'Matricaria': 'Matricaria',
                    'Mikania': 'Mikania',
                    'Nouelia': 'Nouelia',
                    'Paraprenanthes': 'Paraprenanthes',
                    'Parasenecio': 'Parasenecio',
                    'Pertya': 'Pertya',
                    'Phaeostigma': 'Phaeostigma',
                    'Pulicaria': 'Pulicaria',
                    'Rutidosis': 'Rutidosis',
                    'Saussurea': 'Saussurea',
                    'Senecio': 'Senecio',
                    'Solidago': 'Solidago',
                    'Synotis': 'Synotis',
                    'Tagetes': 'Tagetes',
                    'Tanacetum': 'Tanacetum',
                    'Taraxacum': 'Taraxacum',
                    'Tussilago': 'Tussilago',
                },
                'Campanulaceae': {
                    'Codonopsis': 'Codonopsis',
                    'Platycodon': 'Platycodon',
                },
            },
            'Ranunculales': {
                'Ranunculaceae': {
                    'Aconitum': 'Aconitum',
                    'Aquilegia': 'Aquilegia',
                    'Clematis': 'Clematis',
                    'Coptis': 'Coptis',
                    'Hepatica': 'Hepatica',
                    'Paropyrum': 'Paropyrum',
                    'Pulsatilla': 'Pulsatilla',
                    'Ranunculus': 'Ranunculus',
                    'Semiaquilegia': 'Semiaquilegia',
                },
                'Papaveraceae': {
                    'Corydalis': 'Corydalis',
                },
                'Menispermaceae': {
                    'Stephania': 'Stephania',
                },
            },
            'Ericales': {
                'Actinidiaceae': {
                    'Actinidia': 'Actinidia',
                    'Saurauia': 'Saurauia',
                },
                'Primulaceae': {
                    'Aegiceras': 'Aegiceras',
                    'Androsace': 'Androsace',
                    'Primula': 'Primula',
                },
                'Sapotaceae': {
                    'Argania': 'Argania',
                },
                'Theaceae': {
                    'Camellia': 'Camellia',
                    'Stewartia': 'Stewartia',
                },
                'Ericaceae': {
                    'Corema': 'Corema',
                    'Hypopitys': 'Hypopitys',
                    'Rhododendron': 'Rhododendron',
                    'Vaccinium': 'Vaccinium',
                },
                'Ebenaceae': {
                    'Diospyros': 'Diospyros',
                },
                'Symplocaceae': {
                    'Symplocos': 'Symplocos',
                },
            },
            'Lamiales': {
                'Orobanchaceae': {
                    'Aeginetia': 'Aeginetia',
                    'Castilleja': 'Castilleja',
                    'Christisonia': 'Christisonia',
                    'Cistanche': 'Cistanche',
                    'Cymbaria': 'Cymbaria',
                    'Orobanche': 'Orobanche',
                    'Pedicularis': 'Pedicularis',
                    'Rehmannia': 'Rehmannia',
                    'Striga': 'Striga',
                },
                'Lamiaceae': {
                    'Ajuga': 'Ajuga',
                    'Anisomeles': 'Anisomeles',
                    'Elsholtzia': 'Elsholtzia',
                    'Lavandula': 'Lavandula',
                    'Leonurus': 'Leonurus',
                    'Mentha': 'Mentha',
                    'Perilla': 'Perilla',
                    'Platostoma': 'Platostoma',
                    'Pogostemon': 'Pogostemon',
                    'Prunella': 'Prunella',
                    'Rotheca': 'Rotheca',
                    'Salvia': 'Salvia',
                    'Scutellaria': 'Scutellaria',
                    'Vitex': 'Vitex',
                },
                'Plantaginaceae': {
                    'Aragoa': 'Aragoa',
                    'Misopates': 'Misopates',
                    'Plantago': 'Plantago',
                },
                'Acanthaceae': {
                    'Avicennia': 'Avicennia',
                },
                'Scrophulariaceae': {
                    'Buddleja': 'Buddleja',
                },
                'Oleaceae': {
                    'Chionanthus': 'Chionanthus',
                    'Forsythia': 'Forsythia',
                    'Hesperelaea': 'Hesperelaea',
                    'Jasminum': 'Jasminum',
                    'Ligustrum': 'Ligustrum',
                    'Noronhia': 'Noronhia',
                    'Olea': 'Olea',
                    'Osmanthus': 'Osmanthus',
                    'Syringa': 'Syringa',
                },
                'Bignoniaceae': {
                    'Dolichandrone': 'Dolichandrone',
                    'Markhamia': 'Markhamia',
                },
                'Gesneriaceae': {
                    'Dorcoceras': 'Dorcoceras',
                    'Haberlea': 'Haberlea',
                    'Primulina': 'Primulina',
                },
                'Phrymaceae': {
                    'Erythranthe': 'Erythranthe',
                },
                'Lentibulariaceae': {
                    'Genlisea': 'Genlisea',
                    'Utricularia': 'Utricularia',
                },
                'Linderniaceae': {
                    'Picria': 'Picria',
                },
                'Verbenaceae': {
                    'Verbena': 'Verbena',
                },
            },
            'Caryophyllales': {
                'Caryophyllaceae': {
                    'Agrostemma': 'Agrostemma',
                    'Silene': 'Silene',
                },
                'Amaranthaceae': {
                    'Amaranthus': 'Amaranthus',
                    'Beta': 'Beta',
                    'Chenopodium': 'Chenopodium',
                    'Dysphania': 'Dysphania',
                    'Halogeton': 'Halogeton',
                    'Haloxylon': 'Haloxylon',
                    'Spinacia': 'Spinacia',
                    'Suaeda': 'Suaeda',
                },
                'Nyctaginaceae': {
                    'Bougainvillea': 'Bougainvillea',
                    'Mirabilis': 'Mirabilis',
                },
                'Polygonaceae': {
                    'Fagopyrum': 'Fagopyrum',
                    'Fallopia': 'Fallopia',
                    'Polygonum': 'Polygonum',
                    'Reynoutria': 'Reynoutria',
                    'Rheum': 'Rheum',
                },
                'Plumbaginaceae': {
                    'Limonium': 'Limonium',
                },
                'Cactaceae': {
                    'Mammillaria': 'Mammillaria',
                    'Nopalea': 'Nopalea',
                    'Pereskia': 'Pereskia',
                    'Selenicereus': 'Selenicereus',
                },
                'Aizoaceae': {
                    'Mesembryanthemum': 'Mesembryanthemum',
                    'Sesuvium': 'Sesuvium',
                    'Tetragonia': 'Tetragonia',
                },
                'Tamaricaceae': {
                    'Myricaria': 'Myricaria',
                },
                'Nepenthaceae': {
                    'Nepenthes': 'Nepenthes',
                },
                'Chenopodiaceae': {
                    'Salicornia': 'Salicornia',
                },
            },
            'Solanales': {
                'Solanaceae': {
                    'Alkekengi': 'Alkekengi',
                    'Capsicum': 'Capsicum',
                    'Hyoscyamus': 'Hyoscyamus',
                    'Lycium': 'Lycium',
                    'Mandragora': 'Mandragora',
                    'Nicotiana': 'Nicotiana',
                    'Physochlaina': 'Physochlaina',
                    'Solanum': 'Solanum',
                },
                'Convolvulaceae': {
                    'Argyreia': 'Argyreia',
                    'Calystegia': 'Calystegia',
                    'Convolvulus': 'Convolvulus',
                    'Cuscuta': 'Cuscuta',
                    'Dichondra': 'Dichondra',
                    'Dinetus': 'Dinetus',
                    'Erycibe': 'Erycibe',
                    'Evolvulus': 'Evolvulus',
                    'Ipomoea': 'Ipomoea',
                    'Merremia': 'Merremia',
                },
            },
            'Rosales': {
                'Rosaceae': {
                    'Alniaria': 'Alniaria',
                    'Argentina': 'Argentina',
                    'Chaenomeles': 'Chaenomeles',
                    'Comarum': 'Comarum',
                    'Fragaria': 'Fragaria',
                    'Geum': 'Geum',
                    'Karpatiosorbus': 'Karpatiosorbus',
                    'Malus': 'Malus',
                    'Photinia': 'Photinia',
                    'Potentilla': 'Potentilla',
                    'Prinsepia': 'Prinsepia',
                    'Prunus': 'Prunus',
                    'Pyrus': 'Pyrus',
                    'Rhaphiolepis': 'Rhaphiolepis',
                    'Rosa': 'Rosa',
                    'Rubus': 'Rubus',
                    'Sorbus': 'Sorbus',
                    'Spiraea': 'Spiraea',
                    'Taihangia': 'Taihangia',
                    'Torminalis': 'Torminalis',
                },
                'Moraceae': {
                    'Artocarpus': 'Artocarpus',
                    'Ficus': 'Ficus',
                    'Morus': 'Morus',
                },
                'Cannabaceae': {
                    'Cannabis': 'Cannabis',
                    'Humulus': 'Humulus',
                },
                'Ulmaceae': {
                    'Hemiptelea': 'Hemiptelea',
                    'Zelkova': 'Zelkova',
                },
                'Elaeagnaceae': {
                    'Hippophae': 'Hippophae',
                },
                'Rhamnaceae': {
                    'Ziziphus': 'Ziziphus',
                },
            },
            'Fagales': {
                'Betulaceae': {
                    'Alnus': 'Alnus',
                    'Betula': 'Betula',
                },
                'Fagaceae': {
                    'Castanea': 'Castanea',
                    'Castanopsis': 'Castanopsis',
                    'Fagus': 'Fagus',
                    'Lithocarpus': 'Lithocarpus',
                    'Quercus': 'Quercus',
                },
                'Juglandaceae': {
                    'Juglans': 'Juglans',
                },
                'Myricaceae': {
                    'Morella': 'Morella',
                },
            },
            'Apiales': {
                'Apiaceae': {
                    'Anethum': 'Anethum',
                    'Apium': 'Apium',
                    'Bupleurum': 'Bupleurum',
                    'Cicuta': 'Cicuta',
                    'Cnidium': 'Cnidium',
                    'Coriandrum': 'Coriandrum',
                    'Cuminum': 'Cuminum',
                    'Cyclospermum': 'Cyclospermum',
                    'Daucus': 'Daucus',
                    'Dystaenia': 'Dystaenia',
                    'Ferula': 'Ferula',
                    'Oenanthe': 'Oenanthe',
                    'Saposhnikovia': 'Saposhnikovia',
                    'Spuriopimpinella': 'Spuriopimpinella',
                },
                'Araliaceae': {
                    'Eleutherococcus': 'Eleutherococcus',
                    'Hedera': 'Hedera',
                    'Panax': 'Panax',
                    'Polyscias': 'Polyscias',
                },
            },
            'Brassicales': {
                'Brassicaceae': {
                    'Arabidopsis': 'Arabidopsis',
                    'Arabis': 'Arabis',
                    'Boechera': 'Boechera',
                    'Brassica': 'Brassica',
                    'Capsella': 'Capsella',
                    'Descurainia': 'Descurainia',
                    'Eruca': 'Eruca',
                    'Hirschfeldia': 'Hirschfeldia',
                    'Isatis': 'Isatis',
                    'Lepidium': 'Lepidium',
                    'Malcolmia': 'Malcolmia',
                    'Meniocus': 'Meniocus',
                    'Raphanus': 'Raphanus',
                    'Rorippa': 'Rorippa',
                    'Schrenkiella': 'Schrenkiella',
                    'Sinapis': 'Sinapis',
                    'Tetracme': 'Tetracme',
                },
                'Bataceae': {
                    'Batis': 'Batis',
                },
                'Caricaceae': {
                    'Carica': 'Carica',
                },
            },
            'Gentianales': {
                'Apocynaceae': {
                    'Asclepias': 'Asclepias',
                    'Cynanchum': 'Cynanchum',
                    'Hancornia': 'Hancornia',
                    'Hoya': 'Hoya',
                    'Rhazya': 'Rhazya',
                    'Trachelospermum': 'Trachelospermum',
                },
                'Rubiaceae': {
                    'Cinchona': 'Cinchona',
                    'Coffea': 'Coffea',
                    'Damnacanthus': 'Damnacanthus',
                    'Neolamarckia': 'Neolamarckia',
                    'Oldenlandia': 'Oldenlandia',
                    'Psychotria': 'Psychotria',
                    'Scyphiphora': 'Scyphiphora',
                    'Sherardia': 'Sherardia',
                },
                'Gelsemiaceae': {
                    'Gelsemium': 'Gelsemium',
                },
                'Gentianaceae': {
                    'Gentiana': 'Gentiana',
                },
            },
            'Malpighiales': {
                'Malpighiaceae': {
                    'Banisteriopsis': 'Banisteriopsis',
                },
                'Rhizophoraceae': {
                    'Bruguiera': 'Bruguiera',
                    'Kandelia': 'Kandelia',
                },
                'Calophyllaceae': {
                    'Calophyllum': 'Calophyllum',
                },
                'Euphorbiaceae': {
                    'Excoecaria': 'Excoecaria',
                    'Hevea': 'Hevea',
                    'Jatropha': 'Jatropha',
                    'Manihot': 'Manihot',
                    'Mercurialis': 'Mercurialis',
                    'Ricinus': 'Ricinus',
                    'Vernicia': 'Vernicia',
                },
                'Clusiaceae': {
                    'Garcinia': 'Garcinia',
                },
                'Passifloraceae': {
                    'Passiflora': 'Passiflora',
                },
                'Phyllanthaceae': {
                    'Phyllanthus': 'Phyllanthus',
                },
                'Salicaceae': {
                    'Populus': 'Populus',
                    'Salix': 'Salix',
                },
                'Rafflesiaceae': {
                    'Sapria': 'Sapria',
                },
                'Violaceae': {
                    'Viola': 'Viola',
                },
            },
            'Myrtales': {
                'Onagraceae': {
                    'Chamaenerion': 'Chamaenerion',
                    'Clarkia': 'Clarkia',
                    'Oenothera': 'Oenothera',
                },
                'Myrtaceae': {
                    'Eucalyptus': 'Eucalyptus',
                    'Melaleuca': 'Melaleuca',
                    'Psidium': 'Psidium',
                    'Rhodomyrtus': 'Rhodomyrtus',
                    'Syzygium': 'Syzygium',
                },
                'Lythraceae': {
                    'Lagerstroemia': 'Lagerstroemia',
                    'Punica': 'Punica',
                    'Trapa': 'Trapa',
                },
                'Melastomataceae': {
                    'Medinilla': 'Medinilla',
                    'Melastoma': 'Melastoma',
                },
            },
            'Saxifragales': {
                'Saxifragaceae': {
                    'Chrysosplenium': 'Chrysosplenium',
                    'Tiarella': 'Tiarella',
                },
                'Hamamelidaceae': {
                    'Distylium': 'Distylium',
                },
                'Haloragaceae': {
                    'Myriophyllum': 'Myriophyllum',
                },
                'Paeoniaceae': {
                    'Paeonia': 'Paeonia',
                },
                'Crassulaceae': {
                    'Rhodiola': 'Rhodiola',
                    'Sedum': 'Sedum',
                },
                'Grossulariaceae': {
                    'Ribes': 'Ribes',
                },
            },
            'Cucurbitales': {
                'Cucurbitaceae': {
                    'Citrullus': 'Citrullus',
                    'Cucumis': 'Cucumis',
                    'Cucurbita': 'Cucurbita',
                    'Herpetospermum': 'Herpetospermum',
                    'Lagenaria': 'Lagenaria',
                    'Luffa': 'Luffa',
                    'Momordica': 'Momordica',
                    'Thladiantha': 'Thladiantha',
                    'Trichosanthes': 'Trichosanthes',
                },
            },
            'Boraginales': {
                'Boraginaceae': {
                    'Cordia': 'Cordia',
                    'Ehretia': 'Ehretia',
                },
            },
            'Garryales': {
                'Eucommiaceae': {
                    'Eucommia': 'Eucommia',
                },
            },
            'Celastrales': {
                'Celastraceae': {
                    'Euonymus': 'Euonymus',
                    'Tripterygium': 'Tripterygium',
                },
            },
            'Geraniales': {
                'Geraniaceae': {
                    'Geranium': 'Geranium',
                },
            },
            'Santalales': {
                'Loranthaceae': {
                    'Helicanthes': 'Helicanthes',
                    'Tolypanthus': 'Tolypanthus',
                },
                'Balanophoraceae': {
                    'Lophophytum': 'Lophophytum',
                    'Ombrophytum': 'Ombrophytum',
                    'Rhopalocnemis': 'Rhopalocnemis',
                },
                'Ximeniaceae': {
                    'Malania': 'Malania',
                },
                'Santalaceae': {
                    'Santalum': 'Santalum',
                    'Viscum': 'Viscum',
                },
            },
            'Dipsacales': {
                'Caprifoliaceae': {
                    'Heptacodium': 'Heptacodium',
                    'Lonicera': 'Lonicera',
                    'Triosteum': 'Triosteum',
                },
                'Viburnaceae': {
                    'Sambucus': 'Sambucus',
                    'Viburnum': 'Viburnum',
                },
            },
            'Cornales': {
                'Hydrangeaceae': {
                    'Hydrangea': 'Hydrangea',
                },
            },
            'Aquifoliales': {
                'Aquifoliaceae': {
                    'Ilex': 'Ilex',
                },
            },
            'Proteales': {
                'Proteaceae': {
                    'Macadamia': 'Macadamia',
                },
                'Nelumbonaceae': {
                    'Nelumbo': 'Nelumbo',
                },
            },
            'Vitales': {
                'Vitaceae': {
                    'Nekemias': 'Nekemias',
                    'Vitis': 'Vitis',
                },
            },
            'Trochodendrales': {
                'Trochodendraceae': {
                    'Tetracentron': 'Tetracentron',
                },
            },
            'Zygophyllales': {
                'Zygophyllaceae': {
                    'Tetraena': 'Tetraena',
                    'Tribulus': 'Tribulus',
                    'Zygophyllum': 'Zygophyllum',
                },
            },
        },
        'Monocots': {
            'Acorales': {
                'Acoraceae': {
                    'Acorus': 'Acorus',
                },
            },
            'Poales': {
                'Bromeliaceae': {
                    'Aechmea': 'Aechmea',
                    'Ananas': 'Ananas',
                    'Puya': 'Puya',
                },
                'Poaceae': {
                    'Aegilops': 'Aegilops',
                    'Agrostis': 'Agrostis',
                    'Avena': 'Avena',
                    'Bambusa': 'Bambusa',
                    'Bromus': 'Bromus',
                    'Chrysopogon': 'Chrysopogon',
                    'Coix': 'Coix',
                    'Cynodon': 'Cynodon',
                    'Eleusine': 'Eleusine',
                    'Elymus': 'Elymus',
                    'Eremochloa': 'Eremochloa',
                    'Fargesia': 'Fargesia',
                    'Hordeum': 'Hordeum',
                    'Hygroryza': 'Hygroryza',
                    'Indocalamus': 'Indocalamus',
                    'Lolium': 'Lolium',
                    'Microstegium': 'Microstegium',
                    'Nassella': 'Nassella',
                    'Oryza': 'Oryza',
                    'Paspalum': 'Paspalum',
                    'Pennisetum': 'Pennisetum',
                    'Phragmites': 'Phragmites',
                    'Poa': 'Poa',
                    'Saccharum': 'Saccharum',
                    'Secale': 'Secale',
                    'Sorghum': 'Sorghum',
                    'Sporobolus': 'Sporobolus',
                    'Stipa': 'Stipa',
                    'Thinopyrum': 'Thinopyrum',
                    'Tripidium': 'Tripidium',
                    'Tripsacum': 'Tripsacum',
                    'Triticum': 'Triticum',
                    'Zea': 'Zea',
                    'Zizania': 'Zizania',
                },
                'Cyperaceae': {
                    'Bolboschoenus': 'Bolboschoenus',
                    'Carex': 'Carex',
                    'Cyperus': 'Cyperus',
                    'Rhynchospora': 'Rhynchospora',
                    'Schoenoplectus': 'Schoenoplectus',
                },
                'Juncaceae': {
                    'Juncus': 'Juncus',
                    'Luzula': 'Luzula',
                },
            },
            'Asparagales': {
                'Amaryllidaceae': {
                    'Allium': 'Allium',
                },
                'Orchidaceae': {
                    'Apostasia': 'Apostasia',
                    'Bletilla': 'Bletilla',
                    'Danxiaorchis': 'Danxiaorchis',
                    'Dendrobium': 'Dendrobium',
                    'Epipogium': 'Epipogium',
                    'Gastrodia': 'Gastrodia',
                    'Phalaenopsis': 'Phalaenopsis',
                    'Nervilia': 'Nervilia',
                    'Paphiopedilum': 'Paphiopedilum',
                },
                'Asparagaceae': {
                    'Asparagus': 'Asparagus',
                    'Chlorophytum': 'Chlorophytum',
                    'Dracaena': 'Dracaena',
                    'Liriope': 'Liriope',
                    'Polygonatum': 'Polygonatum',
                },
                'Asphodelaceae': {
                    'Hemerocallis': 'Hemerocallis',
                },
                'Iridaceae': {
                    'Iris': 'Iris',
                },
            },
            'Alismatales': {
                'Araceae': {
                    'Amorphophallus': 'Amorphophallus',
                    'Pinellia': 'Pinellia',
                    'Pistia': 'Pistia',
                    'Spirodela': 'Spirodela',
                    'Zantedeschia': 'Zantedeschia',
                },
                'Butomaceae': {
                    'Butomus': 'Butomus',
                },
                'Hydrocharitaceae': {
                    'Halophila': 'Halophila',
                    'Stratiotes': 'Stratiotes',
                },
                'Zosteraceae': {
                    'Phyllospadix': 'Phyllospadix',
                    'Zostera': 'Zostera',
                },
                'Ruppiaceae': {
                    'Ruppia': 'Ruppia',
                },
                'Scheuchzeriaceae': {
                    'Scheuchzeria': 'Scheuchzeria',
                },
            },
            'Arecales': {
                'Arecaceae': {
                    'Areca': 'Areca',
                    'Cocos': 'Cocos',
                    'Phoenix': 'Phoenix',
                },
            },
            'Liliales': {
                'Liliaceae': {
                    'Fritillaria': 'Fritillaria',
                    'Lilium': 'Lilium',
                },
            },
            'Pandanales': {
                'Pandanaceae': {
                    'Pandanus': 'Pandanus',
                },
                'Stemonaceae': {
                    'Stemona': 'Stemona',
                },
            },
            'Commelinales': {
                'Pontederiaceae': {
                    'Pontederia': 'Pontederia',
                },
            },
        },
        'ANA group': {
            'Amborellales': {
                'Amborellaceae': {
                    'Amborella': 'Amborella',
                },
            },
            'Nymphaeales': {
                'Nymphaeaceae': {
                    'Barclaya': 'Barclaya',
                    'Euryale': 'Euryale',
                    'Nymphaea': 'Nymphaea',
                },
                'Cabombaceae': {
                    'Brasenia': 'Brasenia',
                },
            },
            'Austrobaileyales': {
                'Schisandraceae': {
                    'Illicium': 'Illicium',
                    'Schisandra': 'Schisandra',
                },
            },
        },
        'Magnoliids': {
            'Magnoliales': {
                'Annonaceae': {
                    'Annona': 'Annona',
                },
                'Magnoliaceae': {
                    'Houpoea': 'Houpoea',
                    'Liriodendron': 'Liriodendron',
                    'Magnolia': 'Magnolia',
                },
            },
            'Piperales': {
                'Aristolochiaceae': {
                    'Aristolochia': 'Aristolochia',
                },
                'Saururaceae': {
                    'Houttuynia': 'Houttuynia',
                    'Saururus': 'Saururus',
                },
                'Piperaceae': {
                    'Peperomia': 'Peperomia',
                    'Piper': 'Piper',
                },
            },
            'Laurales': {
                'Lauraceae': {
                    'Caryodaphnopsis': 'Caryodaphnopsis',
                    'Cinnamomum': 'Cinnamomum',
                    'Cryptocarya': 'Cryptocarya',
                    'Lindera': 'Lindera',
                    'Machilus': 'Machilus',
                    'Neocinnamomum': 'Neocinnamomum',
                    'Persea': 'Persea',
                    'Umbellularia': 'Umbellularia',
                },
                'Calycanthaceae': {
                    'Chimonanthus': 'Chimonanthus',
                },
                'Hernandiaceae': {
                    'Hernandia': 'Hernandia',
                },
            },
            'Zingiberales': {
                'Zingiberaceae': {
                    'Curcuma': 'Curcuma',
                },
            },
            'Dioscoreales': {
                'Dioscoreaceae': {
                    'Trichopus': 'Trichopus',
                },
            },
        },
        'Chloranthales': {
            'Chloranthales': {
                'Chloranthaceae': {
                    'Chloranthus': 'Chloranthus',
                    'Hedyosmum': 'Hedyosmum',
                },
            },
        },
    },
    'Gymnosperm': {
        'Pinopsida': {
            'Pinales': {
                'Pinaceae': {
                    'Abies': 'Abies',
                    'Larix': 'Larix',
                    'Pinus': 'Pinus',
                    'Cathaya': 'Cathaya',
                },
            },
            'Cupressales': {
                'Cupressaceae': {
                    'Platycladus': 'Platycladus',
                    'Thuja': 'Thuja',
                },
                'Taxaceae': {
                    'Taxus': 'Taxus',
                },
            },
        },
        'Cycadopsida': {
            'Cycadales': {
                'Cycadaceae': {
                    'Cycas': 'Cycas',
                },
            },
        },
        'Ginkgoopsida': {
            'Ginkgoales': {
                'Ginkgoaceae': {
                    'Ginkgo': 'Ginkgo',
                },
            },
        },
        'Gnetopsida': {
            'Welwitschiales': {
                'Welwitschiaceae': {
                    'Welwitschia': 'Welwitschia',
                },
            },
        },
    },
    'Bryophyte': {
        'Andreaeopsida': {
            'Andreaeales': {
                'Andreaeaceae': {
                    'Andreaea': 'Andreaea',
                },
            },
        },
        'Jungermanniopsida': {
            'Metzgeriales': {
                'Aneuraceae': {
                    'Aneura': 'Aneura',
                    'Riccardia': 'Riccardia',
                },
                'Metzgeriaceae': {
                    'Metzgeria': 'Metzgeria',
                },
            },
            'Pelliales': {
                'Pelliaceae': {
                    'Apopellia': 'Apopellia',
                    'Pellia': 'Pellia',
                },
            },
            'Jungermanniales': {
                'Calypogeiaceae': {
                    'Calypogeia': 'Calypogeia',
                },
                'Scapaniaceae': {
                    'Diplophyllum': 'Diplophyllum',
                    'Douinia': 'Douinia',
                    'Scapania': 'Scapania',
                },
                'Gymnomitriaceae': {
                    'Gymnomitrion': 'Gymnomitrion',
                },
                'Jungermanniaceae': {
                    'Jungermannia': 'Jungermannia',
                },
                'Cephaloziaceae': {
                    'Nowellia': 'Nowellia',
                },
                'Lophoziaceae': {
                    'Trilophozia': 'Trilophozia',
                },
            },
            'Fossombroniales': {
                'Fossombroniaceae': {
                    'Fossombronia': 'Fossombronia',
                },
            },
            'Pallaviciniales': {
                'Moerckiaceae': {
                    'Moerckia': 'Moerckia',
                },
                'Pallaviciniaceae': {
                    'Pallavicinia': 'Pallavicinia',
                },
            },
            'Pleuroziales': {
                'Pleuroziaceae': {
                    'Pleurozia': 'Pleurozia',
                },
            },
            'Porellales': {
                'Porellaceae': {
                    'Porella': 'Porella',
                },
            },
            'Ptilidiales': {
                'Ptilidiaceae': {
                    'Ptilidium': 'Ptilidium',
                },
            },
        },
        'Bryopsida': {
            'Hypnales': {
                'Anomodontaceae': {
                    'Anomodon': 'Anomodon',
                },
                'Brachytheciaceae': {
                    'Brachythecium': 'Brachythecium',
                    'Myuroclada': 'Myuroclada',
                },
                'Hypnaceae': {
                    'Callicladium': 'Callicladium',
                },
                'Climaciaceae': {
                    'Climacium': 'Climacium',
                },
                'Plagiotheciaceae': {
                    'Myurella': 'Myurella',
                },
                'Neckeraceae': {
                    'Planicladium': 'Planicladium',
                    'Pseudanomodon': 'Pseudanomodon',
                },
                'Ptychomniaceae': {
                    'Ptychomnion': 'Ptychomnion',
                },
                'Amblystegiaceae': {
                    'Sanionia': 'Sanionia',
                },
            },
            'Rhizogoniales': {
                'Aulacomniaceae': {
                    'Aulacomnium': 'Aulacomnium',
                },
            },
            'Bartramiales': {
                'Bartramiaceae': {
                    'Bartramia': 'Bartramia',
                },
            },
            'Grimmiales': {
                'Grimmiaceae': {
                    'Bucklandiella': 'Bucklandiella',
                    'Codriophorus': 'Codriophorus',
                    'Dilutineuron': 'Dilutineuron',
                    'Frisvollia': 'Frisvollia',
                    'Niphotrichum': 'Niphotrichum',
                    'Racomitrium': 'Racomitrium',
                },
            },
            'Buxbaumiales': {
                'Buxbaumiaceae': {
                    'Buxbaumia': 'Buxbaumia',
                },
            },
            'Pottiales': {
                'Pottiaceae': {
                    'Chionoloma': 'Chionoloma',
                    'Pseudocrossidium': 'Pseudocrossidium',
                    'Syntrichia': 'Syntrichia',
                    'Tortula': 'Tortula',
                },
            },
            'Dicranales': {
                'Dicranaceae': {
                    'Chorisodontium': 'Chorisodontium',
                    'Dicranum': 'Dicranum',
                },
            },
            'Funariales': {
                'Funariaceae': {
                    'Funaria': 'Funaria',
                    'Physcomitrium': 'Physcomitrium',
                },
            },
            'Bryales': {
                'Mniaceae': {
                    'Mielichhoferia': 'Mielichhoferia',
                    'Pohlia': 'Pohlia',
                },
            },
            'Orthotrichales': {
                'Orthotrichaceae': {
                    'Orthotrichum': 'Orthotrichum',
                    'Plenogemma': 'Plenogemma',
                    'Stoneobryum': 'Stoneobryum',
                    'Ulota': 'Ulota',
                    'Zygodon': 'Zygodon',
                },
            },
            'Isobryales': {
                'Orthotrichaceae': {
                    'Orthotrichum': 'Orthotrichum',
                },
            },
            'Splachnales': {
                'Splachnaceae': {
                    'Tetraplodon': 'Tetraplodon',
                },
            },
        },
        'Anthocerotopsida': {
            'Anthocerotales': {
                'Anthocerotaceae': {
                    'Anthoceros': 'Anthoceros',
                    'Phaeoceros': 'Phaeoceros',
                },
            },
            'Dendrocerotales': {
                'Dendrocerotaceae': {
                    'Nothoceros': 'Nothoceros',
                },
            },
        },
        'Polytrichopsida': {
            'Polytrichales': {
                'Polytrichaceae': {
                    'Atrichum': 'Atrichum',
                    'Pogonatum': 'Pogonatum',
                    'Polytrichum': 'Polytrichum',
                },
            },
        },
        'Marchantiopsida': {
            'Marchantiales': {
                'Targioniaceae': {
                    'Cyathodium': 'Cyathodium',
                },
                'Dumortieraceae': {
                    'Dumortiera': 'Dumortiera',
                },
                'Marchantiaceae': {
                    'Marchantia': 'Marchantia',
                },
                'Ricciaceae': {
                    'Riccia': 'Riccia',
                },
                'Wiesnerellaceae': {
                    'Wiesnerella': 'Wiesnerella',
                },
            },
        },
        'Haplomitriopsida': {
            'Calobryales': {
                'Haplomitriaceae': {
                    'Haplomitrium': 'Haplomitrium',
                },
            },
            'Treubiales': {
                'Treubiaceae': {
                    'Treubia': 'Treubia',
                },
            },
        },
        'Leiosporocerotopsida': {
            'Leiosporocerotales': {
                'Leiosporocerotaceae': {
                    'Leiosporoceros': 'Leiosporoceros',
                },
            },
        },
        'Ulvophyceae': {
            'Ulvales': {
                'Monostro-taceae': {
                    'Monostroma': 'Monostroma',
                },
            },
        },
        'Sphagnopsida': {
            'Sphagnales': {
                'Sphagnaceae': {
                    'Sphagnum': 'Sphagnum',
                },
            },
        },
        'Tetraphidopsida': {
            'Tetraphidales': {
                'Tetraphidaceae': {
                    'Tetraphis': 'Tetraphis',
                },
            },
        },
    },
    'Phycophyta': {
        'Chlorophyceae': {
            'Sphaeropleales': {
                'Chlorellaceae': {
                    'Ankistrodesmus': 'Ankistrodesmus',
                },
                'Bracteacoccaceae': {
                    'Bracteacoccus': 'Bracteacoccus',
                },
                'Neochloridaceae': {
                    'Chlorotetraedron': 'Chlorotetraedron',
                    'Neochloris': 'Neochloris',
                },
                'Chromochloridaceae': {
                    'Chromochloris': 'Chromochloris',
                },
                'Scenedesmaceae': {
                    'Hariotina': 'Hariotina',
                    'Pectinodesmus': 'Pectinodesmus',
                    'Tetradesmus': 'Tetradesmus',
                },
                'Selenastraceae': {
                    'Monoraphidium': 'Monoraphidium',
                    'Ourococcus': 'Ourococcus',
                },
                'Mychonastaceae': {
                    'Mychonastes': 'Mychonastes',
                },
                'Hydrodictyaceae': {
                    'Pediastrum': 'Pediastrum',
                },
                'Pseudomuriellaceae': {
                    'Pseudomuriella': 'Pseudomuriella',
                },
                'unclassified Sphaeropleales': {
                    'Sphaeropleales': 'Sphaeropleales',
                },
            },
            'Oedogoniales': {
                'Oedogoniaceae': {
                    'Bulbochaete': 'Bulbochaete',
                },
            },
            'Chaetophorales': {
                'Chaetosphaeridiaceae': {
                    'Chaetosphaeridium': 'Chaetosphaeridium',
                },
                'Chaetophoraceae': {
                    'Stigeoclonium': 'Stigeoclonium',
                },
            },
            'Chlamydomonadales': {
                'Chlamydomonadaceae': {
                    'Chlamydomonas': 'Chlamydomonas',
                    'Polytoma': 'Polytoma',
                    'Polytomella': 'Polytomella',
                },
                'Volvocaceae': {
                    'Colemanosphaera': 'Colemanosphaera',
                    'Eudorina': 'Eudorina',
                    'Gonium': 'Gonium',
                    'Pandorina': 'Pandorina',
                    'Pleodorina': 'Pleodorina',
                    'Yamagishiella': 'Yamagishiella',
                },
                'Dunaliellaceae': {
                    'Dunaliella': 'Dunaliella',
                },
                'Chlamydomonadales incertae sedis': {
                    'Edaphochlamys': 'Edaphochlamys',
                    'Leontynka': 'Leontynka',
                    'Limnomonas': 'Limnomonas',
                },
                'Haematococcaceae': {
                    'Haematococcus': 'Haematococcus',
                },
                'Pleurastraceae': {
                    'Pleurastrum': 'Pleurastrum',
                },
            },
            'Chlorosarcinales': {
                'Chlorosarcinaceae': {
                    'Chlorosarcinopsis': 'Chlorosarcinopsis',
                },
            },
            'Chaetopeltidales': {
                'Chaetopeltidaceae': {
                    'Gormaniella': 'Gormaniella',
                },
            },
            'Chlorophyceae incertae sedis': {
                'Microsporaceae': {
                    'Microspora': 'Microspora',
                },
            },
        },
        'Trebouxiophyceae': {
            'Chlorellales': {
                'Chlorellaceae': {
                    'Auxenochlorella': 'Auxenochlorella',
                    'Chlorella': 'Chlorella',
                    'Dicloster': 'Dicloster',
                    'Graesiella': 'Graesiella',
                    'Helicosporidium': 'Helicosporidium',
                    'Marvania': 'Marvania',
                    'Micractinium': 'Micractinium',
                    'Prototheca': 'Prototheca',
                    'Pseudochlorella': 'Pseudochlorella',
                },
                'Oocystaceae': {
                    'Binuclearia': 'Binuclearia',
                },
            },
            'Trebouxiophyceae incertae sedis': {
                'Elliptochloris clade': {
                    'Coccomyxa': 'Coccomyxa',
                },
            },
            'Prasiolales': {
                'Stichococcaceae': {
                    'Diplosphaera': 'Diplosphaera',
                },
                'Koliellaceae': {
                    'Koliella': 'Koliella',
                },
            },
            'Trebouxiales': {
                'Trebouxiaceae': {
                    'Lobosphaera': 'Lobosphaera',
                    'Myrmecia': 'Myrmecia',
                    'Symbiochloris': 'Symbiochloris',
                    'Trebouxia': 'Trebouxia',
                },
            },
            'Microthamniales': {
                'Microthamniaceae': {
                    'Microthamnion': 'Microthamnion',
                },
            },
        },
        'Mamiellophyceae': {
            'Mamiellales': {
                'Bathycoccaceae': {
                    'Bathycoccus': 'Bathycoccus',
                    'Ostreococcus': 'Ostreococcus',
                },
                'Mamiellaceae': {
                    'Micromonas': 'Micromonas',
                },
            },
            'Monomastigales': {
                'Monomastigaceae': {
                    'Monomastix': 'Monomastix',
                },
            },
        },
        'Ulvophyceae': {
            'Bryopsidales': {
                'Bryopsidaceae': {
                    'Bryopsis': 'Bryopsis',
                },
                'Caulerpaceae': {
                    'Caulerpa': 'Caulerpa',
                },
                'Codiaceae': {
                    'Codium': 'Codium',
                },
                'Ostreobiaceae': {
                    'Ostreobium': 'Ostreobium',
                },
            },
            'Ulvales': {
                'Monostromataceae': {
                    'Gayralia': 'Gayralia',
                },
                'Kornmanniaceae': {
                    'Percursaria': 'Percursaria',
                },
                'Ulvaceae': {
                    'Pseudoneochloris': 'Pseudoneochloris',
                    'Ulva': 'Ulva',
                },
            },
            'Ulotrichales': {
                'Ulotrichaceae': {
                    'Gloeotilopsis': 'Gloeotilopsis',
                },
                'Hazeniaceae': {
                    'Hazenia': 'Hazenia',
                },
                'Helicodictyaceae': {
                    'Rhexinema': 'Rhexinema',
                },
                'Tupiellaceae': {
                    'Tupiella': 'Tupiella',
                },
            },
            'Oltmannsiellopsidales': {
                'Oltmannsiellopsidaceae': {
                    'Oltmannsiellopsis': 'Oltmannsiellopsis',
                },
            },
        },
        'Charophyceae': {
            'Charales': {
                'Characeae': {
                    'Chara': 'Chara',
                    'Nitella': 'Nitella',
                    'Nitellopsis': 'Nitellopsis',
                },
            },
        },
        'Chlorokybophyceae': {
            'Chlorokybales': {
                'Chlorokybaceae': {
                    'Chlorokybus': 'Chlorokybus',
                },
            },
        },
        'Chloropicophyceae': {
            'Chloropicales': {
                'Chloropicaceae': {
                    'Chloroparvula': 'Chloroparvula',
                    'Chloropicon': 'Chloropicon',
                },
            },
        },
        'Zygnemophyceae': {
            'Desmidiales': {
                'Closteriaceae': {
                    'Closterium': 'Closterium',
                },
                'Gonatozygaceae': {
                    'Gonatozygon': 'Gonatozygon',
                },
            },
            'Zygnematales': {
                'Klebsormidiaceae': {
                    'Entransia': 'Entransia',
                },
                'Mesotaeniaceae': {
                    'Roya': 'Roya',
                },
                'Zygnemataceae': {
                    'Zygnema': 'Zygnema',
                },
            },
        },
        'Coleochaetophyceae': {
            'Coleochaetales': {
                'Coleochaetaceae': {
                    'Coleochaete': 'Coleochaete',
                },
            },
        },
        'Pyramimonadophyceae': {
            'Pyramimonadales': {
                'Pyramimonadaceae': {
                    'Cymbomonas': 'Cymbomonas',
                    'Pyramimonas': 'Pyramimonas',
                },
            },
        },
        'Klebsormidiophyceae': {
            'Klebsormidiales': {
                'Klebsormidiaceae': {
                    'Interfilum': 'Interfilum',
                },
            },
        },
        'Pedinophyceae': {
            'Marsupiomonadales': {
                'Marsupiomonadaceae': {
                    'Marsupiomonas': 'Marsupiomonas',
                },
            },
            'Pedinomonadales': {
                'Pedinomonadaceae': {
                    'Pedinomonas': 'Pedinomonas',
                },
            },
        },
        'Mesostigmatophyceae': {
            'Mesostigmatales': {
                'Mesostigmataceae': {
                    'Mesostigma': 'Mesostigma',
                },
            },
        },
        'Nephroselmidophyceae': {
            'Nephroselmidales': {
                'Nephroselmidaceae': {
                    'Nephroselmis': 'Nephroselmis',
                },
            },
        },
        'Picocystophyceae': {
            'Picocystales': {
                'Picocystaceae': {
                    'Picocystis': 'Picocystis',
                },
            },
        },
        'Palmophyllophyceae': {
            'Prasinococcales': {
                'Prasinococcaceae': {
                    'Prasinococcus': 'Prasinococcus',
                },
            },
        },
        'Prasinodermophyceae': {
            'Prasinodermales': {
                'Prasinodermaceae': {
                    'Prasinoderma': 'Prasinoderma',
                },
            },
        },
        'Chlorodendrophyceae': {
            'Chlorodendrales': {
                'Chlorodendraceae': {
                    'Scherffelia': 'Scherffelia',
                    'Tetraselmis': 'Tetraselmis',
                },
            },
        },
        'Bryopsida': {
            'Orthotrichales': {
                'Orthotrichaceae': {
                    'Stoneobryum': 'Stoneobryum',
                },
            },
        },
    },
    'Pteridophyte': {
        'Polypodiopsida': {
            'Salviniales': {
                'Salviniaceae': {
                    'Azolla': 'Azolla',
                },
            },
            'Polypodiales': {
                'Blechnaceae': {
                    'Blechnopsis': 'Blechnopsis',
                },
                'Dryopteridaceae': {
                    'Dryopteris': 'Dryopteris',
                },
                'Pteridaceae': {
                    'Haplopteris': 'Haplopteris',
                },
                'Dennstaedtiaceae': {
                    'Pteridium': 'Pteridium',
                },
            },
            'Ophioglossales': {
                'Ophioglossaceae': {
                    'Ophioglossum': 'Ophioglossum',
                },
            },
            'Psilotales': {
                'Psilotaceae': {
                    'Psilotum': 'Psilotum',
                },
            },
        },
        'Lycopodiopsida': {
            'Lycopodiales': {
                'Lycopodiaceae': {
                    'Huperzia': 'Huperzia',
                    'Lycopodium': 'Lycopodium',
                    'Phlegmariurus': 'Phlegmariurus',
                    'Phylloglossum': 'Phylloglossum',
                },
            },
        },
        'Equisetopsida': {
            'Osmundales': {
                'Osmundaceae': {
                    'Osmunda': 'Osmunda',
                },
            },
        },
    },
}
